import { render, staticRenderFns } from "./gift_list.vue?vue&type=template&id=3da2b004&scoped=true&"
import script from "./gift_list.vue?vue&type=script&lang=js&"
export * from "./gift_list.vue?vue&type=script&lang=js&"
import style0 from "./gift_list.vue?vue&type=style&index=0&id=3da2b004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da2b004",
  null
  
)

export default component.exports